module.exports = __webpack_public_path__ + "static/img/third1_7_active.c7ea2f08.png";